var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adData.length)?_c('div',{staticClass:"bottomAdvertContainer",style:({bottom: `${ this.bottomHeight}px`})},[_c('div',{staticClass:"advertIMg"},[_c('img',{attrs:{"src":_vm.adData[0].images,"alt":""},on:{"click":function($event){return _vm.onClickJump()}}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }